<div class="product-selection-container">
  @if (ruleGroupsArray) {
    @for (ruleGroup of ruleGroupsArray.controls; track ruleGroup; let i = $index) {
      @if (i > 0) {
        <div class="or-separator">
          <span class="or-separator__text">OR</span>
        </div>
      }
      <pdq-collapsed [initialCollapsed]="false" [formGroup]="getRuleGroupFormGroup(i)">
        <pdq-collapsed-header>
          <div class="rule-group-header">
            <div class="rule-group-header__left">
              <span class="rule-group-header__title">Product Rule Group {{ i + 1 }}</span>
              <span class="rule-group-header__summary">{{ getRuleGroupSummary(i) }}</span>
            </div>
            <div class="rule-group-header__actions">
              <img
                src="assets/icons/copy-to-clipboard.svg"
                alt="Copy rule group"
                class="rule-group-header__action-icon"
                matTooltip="Copy rule group"
                matTooltipClass="pdq-mat-tooltip"
                (click)="duplicateRuleGroup(i); $event.stopPropagation()" />
              @if (ruleGroupsArray.length > 1) {
                <pdq-button
                  icon="trash"
                  size="small"
                  variant="ghost"
                  class="rule-group-header__delete-btn"
                  matTooltip="Delete rule group"
                  matTooltipClass="pdq-mat-tooltip"
                  (click)="removeRuleGroup(i); $event.stopPropagation()">
                </pdq-button>
              }
            </div>
          </div>
        </pdq-collapsed-header>
        <pdq-collapsed-content>
          <div class="rule-group-content">
            <!-- Trigger Products Section -->
            <div class="rule-section" formGroupName="productsInCart">
              <pdq-heading element="h5" class="rule-section__heading">Trigger Products</pdq-heading>
              <div class="rule-section__header">
                <span class="rule-section__label">If Products In Cart Are:</span>
                @if (getProductsInCartMode(i) === 'smart') {
                  <button
                    type="button"
                    class="view-products-btn"
                    [class.loading]="isLoadingProductsInCart(i)"
                    [disabled]="isLoadingProductsInCart(i)"
                    matTooltip="Click this to preview the products that match your current smart rules."
                    matTooltipClass="pdq-mat-tooltip"
                    (click)="onViewProductsInCart(i)">
                    @if (isLoadingProductsInCart(i)) {
                      <span class="view-products-btn__spinner"></span>
                      Loading...
                    } @else {
                      View products
                    }
                  </button>
                }
              </div>
              <div class="toggle-group">
                <button
                  type="button"
                  (click)="setProductsInCartMode(i, 'manual')"
                  [class.active]="getProductsInCartMode(i) === 'manual'">
                  Specific Products
                </button>
                <button
                  type="button"
                  (click)="setProductsInCartMode(i, 'smart')"
                  [class.active]="getProductsInCartMode(i) === 'smart'">
                  Smart Selection
                </button>
              </div>

              <div class="radio">
                <div class="radio__title">Upgrade Will Apply When</div>
                <pdq-radio-group formControlName="productsMatchMode">
                  <pdq-radio-button
                    value="any"
                    [checked]="getRuleGroupFormGroup(i).get('productsInCart.productsMatchMode')?.value === 'any'"
                    text="Any Of The Products Selected Are In Cart">
                  </pdq-radio-button>
                  <pdq-radio-button
                    value="all"
                    [checked]="getRuleGroupFormGroup(i).get('productsInCart.productsMatchMode')?.value === 'all'"
                    text="All Of The Products Selected Are In Cart">
                  </pdq-radio-button>
                </pdq-radio-group>
              </div>

              @if (getProductsInCartMode(i) === 'smart') {
                <pdq-rules-dynamic-form
                  [formGroup]="getRuleGroupFormGroup(i).get('productsInCart')"
                  formArrayFieldName="rules"
                  [rules]="productsInCartRules"
                  [entities]="productsInCartEntities"
                  [versionWithOrOperator]="true">
                </pdq-rules-dynamic-form>
                @if (getProductsInCart(i).length > 0) {
                  <div class="product-list-section">
                    <span class="product-list-section__label"
                      >Matching Products ({{ getProductsInCart(i).length }})</span
                    >
                    <pdq-product-list
                      [products]="getProductsInCartForDisplay(i)"
                      [showSearch]="true"
                      [showRemove]="false"
                      [showEdit]="false"
                      [showExternalLink]="true"
                      emptyMessage="No matching products"
                      (externalLink)="onExternalLink($event)">
                    </pdq-product-list>
                  </div>
                }
              }
              @if (getProductsInCartMode(i) === 'manual') {
                <div class="product-list-section">
                  <span class="product-list-section__label">Trigger Products</span>
                  <pdq-product-list
                    variant="summary"
                    [products]="getProductsInCartForDisplay(i)"
                    emptyMessage="No products selected"
                    (actionClick)="onAddProductsInCart(i)">
                  </pdq-product-list>
                </div>
              }
            </div>

            <pdq-divider></pdq-divider>

            <!-- Upgrade Products Section -->
            <div class="rule-section" formGroupName="upgradeProducts">
              <pdq-heading element="h5" class="rule-section__heading">Upgrade Products</pdq-heading>
              <div class="radio">
                <div class="radio__title">Upgrade Will Apply When</div>
                <pdq-radio-group formControlName="upgradeType">
                  @for (option of upgradeTypeOptions; track option.value) {
                    <pdq-radio-button
                      [value]="option.value"
                      [checked]="getUpgradeType(i) === option.value"
                      [text]="option.text"
                      [subText]="option.description"
                      [disabled]="option.value === 'subscription' && !canUseSubscription">
                    </pdq-radio-button>
                  }
                </pdq-radio-group>
              </div>

              @if (!canUseSubscription || layoutSwitched) {
                <div class="subscription-note-slot">
                  @if (!canUseSubscription) {
                    <div class="subscription-note subscription-note--info">
                      <span class="subscription-note__icon"></span>
                      <div class="subscription-note__text">
                        <p>Subscription upgrades need the Focused Offer layout.</p>
                        <button type="button" class="subscription-note__link" (click)="switchToFocusedOffer.emit()">
                          Switch now
                        </button>
                      </div>
                    </div>
                  } @else {
                    <div class="subscription-note subscription-note--success">
                      <span class="subscription-note__icon"></span>
                      <p class="subscription-note__text">
                        Layout switched to Focused Offer.
                        <button type="button" class="subscription-note__link" (click)="undoLayoutSwitch.emit()">
                          Undo
                        </button>
                      </p>
                    </div>
                  }
                </div>
              }

              @if (isSubscription(i)) {
                <div class="radio behavior-nested">
                  <div class="radio__title">Behavior</div>
                  <div class="option-cards">
                    @for (option of subscriptionBehaviorOptions; track option.value) {
                      <div
                        class="option-card"
                        [class.option-card--selected]="getSubscriptionUpgradeBehavior(i) === option.value"
                        (click)="selectSubscriptionBehavior(i, option.value)">
                        <div
                          class="option-card__radio"
                          [class.option-card__radio--checked]="
                            getSubscriptionUpgradeBehavior(i) === option.value
                          "></div>
                        <div class="option-card__content">
                          <span class="option-card__title">{{ option.text }}</span>
                          <span class="option-card__description">{{ option.description }}</span>
                        </div>
                      </div>
                    }
                  </div>

                  <div class="group-by-key-nested">
                    <pdq-checkbox
                      [checked]="isGroupByKeyEnabled(i)"
                      (onChange)="toggleGroupByKey(i, $event)"
                      label="Group by key"
                      secondaryLabel="Walk the upgrade across variants that share this option value (e.g. Flavor). To group by more than one option, separate the names with a comma (e.g. color, size). Sequential climbs every tier; One time offers the next tier up once."
                      labelSize="small">
                    </pdq-checkbox>

                    @if (isGroupByKeyEnabled(i)) {
                      <div class="group-by-key-field">
                        <pdq-input
                          formControlName="groupByKey"
                          label="Group by option name"
                          placeholder="e.g. Flavor"></pdq-input>
                      </div>
                    }
                  </div>
                </div>
              }

              @if (!isSubscription(i)) {
                <div class="rule-section__header">
                  <span class="rule-section__label">Select products to offer as an upgrade</span>
                  @if (getUpgradeProductsMode(i) === 'smart') {
                    <button
                      type="button"
                      class="view-products-btn"
                      [class.loading]="isLoadingProducts(i)"
                      [disabled]="isLoadingProducts(i)"
                      matTooltip="Click this to preview the products that match your current smart rules."
                      matTooltipClass="pdq-mat-tooltip"
                      (click)="onViewUpgradeProducts(i)">
                      @if (isLoadingProducts(i)) {
                        <span class="view-products-btn__spinner"></span>
                        Loading...
                      } @else {
                        View products
                      }
                    </button>
                  }
                </div>
                <div class="toggle-group">
                  <button
                    type="button"
                    (click)="setUpgradeProductsMode(i, 'manual')"
                    [class.active]="getUpgradeProductsMode(i) === 'manual'">
                    Specific Products
                  </button>
                  <button
                    type="button"
                    (click)="setUpgradeProductsMode(i, 'smart')"
                    [class.active]="getUpgradeProductsMode(i) === 'smart'">
                    Smart Selection
                  </button>
                </div>
                <span class="rule-section__helper-text">{{
                  getUpgradeProductsHelperText(getUpgradeProductsMode(i))
                }}</span>

                @if (getUpgradeProductsMode(i) === 'manual') {
                  <div class="product-list-section">
                    <span class="product-list-section__label">Upgrade Products</span>
                    <pdq-product-list
                      variant="summary"
                      [products]="getUpgradeProductsForDisplay(i)"
                      emptyMessage="No products selected"
                      (actionClick)="onAddUpgradeProducts(i)">
                    </pdq-product-list>
                  </div>
                }

                @if (getUpgradeProductsMode(i) === 'smart') {
                  <pdq-rules-dynamic-form
                    [formGroup]="getRuleGroupFormGroup(i).get('upgradeProducts')"
                    formArrayFieldName="rules"
                    [rules]="upgradeProductsRules"
                    [entities]="upgradeProductsEntities"
                    [versionWithOrOperator]="true">
                  </pdq-rules-dynamic-form>
                  @if (getUpgradeProducts(i).length > 0) {
                    <div class="product-list-section">
                      <span class="product-list-section__label"
                        >Matching Products ({{ getUpgradeProducts(i).length }})</span
                      >
                      <pdq-product-list
                        [products]="getUpgradeProductsForDisplay(i)"
                        [showSearch]="true"
                        [showRemove]="false"
                        [showEdit]="false"
                        [showExternalLink]="true"
                        emptyMessage="No matching products"
                        (externalLink)="onExternalLink($event)">
                      </pdq-product-list>
                    </div>
                  }
                }
              }
            </div>

            <pdq-divider></pdq-divider>

            <!-- Product Restrictions Section -->
            <div class="restrictions-section">
              <div class="radio__title">Product Restrictions</div>
              <div class="restrictions-card">
                <div class="restriction-item">
                  <pdq-checkbox
                    formControlName="inStockProductsOnly"
                    label="In-stock products only"
                    secondaryLabel="Only show upgrade products that have available inventory."
                    labelSize="small">
                  </pdq-checkbox>
                </div>
                <div class="restriction-item">
                  <pdq-checkbox
                    formControlName="matchFulfillmentCenterToCartItems"
                    label="Match fulfillment center"
                    secondaryLabel="Only show products that can be fulfilled from the same location as the cart items."
                    labelSize="small">
                  </pdq-checkbox>
                </div>
                <div class="restriction-item">
                  <pdq-checkbox
                    formControlName="includeDigitalItems"
                    label="Include digital items"
                    secondaryLabel="Allow digital products (non-shippable items) to appear as upgrades."
                    labelSize="small">
                  </pdq-checkbox>
                </div>
                @if (!isSubscription(i)) {
                  <div class="restriction-item">
                    <pdq-checkbox
                      [checked]="getHideProductsValue(i) !== 'none'"
                      (onChange)="toggleHideProducts(i, $event)"
                      label="Hide products already in cart"
                      secondaryLabel="Don't show upgrade products that the customer has already added to their cart."
                      labelSize="small">
                    </pdq-checkbox>
                    @if (getHideProductsValue(i) !== 'none') {
                      <div class="restriction-nested">
                        <div class="radio__title">Detection Level</div>
                        <pdq-radio-group
                          [ngModel]="getHideProductsValue(i)"
                          (ngModelChange)="setHideProductsValue(i, $event)"
                          [ngModelOptions]="{ standalone: true }">
                          @for (option of hideProductsOptions; track option.value) {
                            <pdq-radio-button
                              [value]="option.value"
                              [checked]="getHideProductsValue(i) === option.value"
                              [text]="option.label"
                              [subText]="option.description">
                            </pdq-radio-button>
                          }
                        </pdq-radio-group>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </pdq-collapsed-content>
      </pdq-collapsed>
    }
  }

  <button type="button" class="add-rule-group-btn" (click)="addRuleGroup()">+ Add Rule Group</button>
</div>
